import moment from "moment"
import "moment-timezone"

export function fnFormatDate(
  date,
  cformat = "DD/MM/YYYY - HH:mm",
  bUseTimezone = false,
  cUserTimezone = "America/Sao_Paulo",
  cOriginFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
) {
  if (!date || date?.length <= 1) return ""

  try {
    let resp = bUseTimezone
      ? moment(date, cOriginFormat).utc(date).tz(cUserTimezone).format(cformat)
      : moment(date, cOriginFormat).format(cformat)
    if (resp === "Invalid date") resp = ""
    return resp
  } catch (err) {
    console.log(err)
    return ""
  }
}

export function fnFormatDateFromDate(date, cformat = "DD/MM/YYYY - HH:mm") {
  if (!date || date?.length <= 1) return ""

  try {
    return moment(date).format(cformat)
  } catch (err) {
    return ""
  }
}

export function fnFormatDateFromUTC(
  date,
  cformat = "DD/MM/YYYY - HH:mm",
  cUserTimezone = "America/Sao_Paulo",
) {
  if (!date || date?.length <= 1) return ""

  let utc = moment.utc(date).tz(cUserTimezone)

  try {
    return utc.format(cformat)
  } catch (err) {
    return ""
  }
}

// The initial format has to be "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
export function fnFormatDateToUTC(
  date,
  cUserTimezone = "America/Sao_Paulo",
  cformat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
) {
  if (!date || date?.length <= 1) return ""

  try {
    // const utcDate = moment.parseZone(date, cformat).tz(cUserTimezone).utc()
    const utcDate = moment.tz(date, cformat, cUserTimezone).utc()
    return utcDate.format(cformat)
  } catch (err) {
    console.log(err)
    return ""
  }
}

//create a function to convert date with user timezone date to UTC
export function fnFormatDateToUTCFromDate(
  date,
  cUserTimezone = "America/Sao_Paulo",
  cformat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
) {
  if (!date || date?.length <= 1) return ""

  try {
    const utcDate = moment(date).tz(cUserTimezone).utc()
    return utcDate.format(cformat)
  } catch (err) {
    console.log(err)
    return ""
  }
}

//create a function to convert date UTC to user timezone date
export function fnFormatDateFromUTCFromDate(
  date,
  cUserTimezone = "America/Sao_Paulo",
  cformat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]",
) {
  if (!date || date?.length <= 1) return ""
  try {
    const utcDate = moment(date).tz(cUserTimezone)

    return utcDate.format(cformat)
  } catch (err) {
    console.log(err)
    return ""
  }
}

export function fnIsValidDate(date) {
  if (!date?.length) return false

  try {
    const [y, M, d] = date.split(/[- : T Z]/)
    return y && M <= 12 && d <= 31 ? true : false
  } catch (err) {
    return false
  }
}

export function fnIsValidDateBr(date) {
  if (!date?.length) return false

  try {
    const [d, M, y] = date.split(/[/ : T Z]/)
    return y && M <= 12 && d <= 31 ? true : false
  } catch (err) {
    return false
  }
}

export function fnFormatedNumber(number, dec = 2) {
  if (typeof number !== 'number' && isNaN(number)) return 0

  const hasDecimals = number % 1 !== 0;

  const formattedNumber = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: hasDecimals ? dec : 0,
    maximumFractionDigits: hasDecimals ? dec : 0,
  }).format(number)

  return formattedNumber
}